import { useEffect } from 'react';
import {
  useAccount,
  useContractWrite,
  usePrepareContractWrite,
  useWaitForTransaction,
} from 'wagmi';
import config from '../constants/config';
import useSnackbarRpcError from './useSnackbarRpcError';
import useSnackbarRpcSuccess from './useSnackbarRpcSuccess';

const useStakeFancyBear = (
  tokenId?: number,
  onSuccess?: () => void
): [stake: () => void, isLoading: boolean] => {
  const { address } = useAccount();

  const { config: writeConfig } = usePrepareContractWrite({
    addressOrName: config.contracts.fancyBearsContract.address,
    contractInterface: config.contracts.fancyBearsContract.interface,
    functionName: 'safeTransferFrom',
    args: [address, config.contracts.fancyBearStakingContract.address, tokenId],
  });

  const {
    write,
    data: writeData,
    error: writeError,
    isLoading,
  } = useContractWrite(writeConfig);

  const {
    data: waitData,
    error: waitError,
    isLoading: isWaitLoading,
  } = useWaitForTransaction({
    hash: writeData?.hash,
    confirmations: 2,
  });

  useSnackbarRpcError(writeError);
  useSnackbarRpcError(waitError);
  useSnackbarRpcSuccess(waitData);

  useEffect(() => {
    if (!isLoading && waitData && onSuccess) {
      onSuccess();
    }
  }, [isLoading, waitData, tokenId, onSuccess]);

  return [write as () => void, isLoading || isWaitLoading];
};

export default useStakeFancyBear;
